import { render } from "./IndividualSportsResults.vue?vue&type=template&id=3e0131a6&scoped=true"
import script from "./IndividualSportsResults.vue?vue&type=script&lang=js"
export * from "./IndividualSportsResults.vue?vue&type=script&lang=js"

import "./IndividualSportsResults.vue?vue&type=style&index=0&id=3e0131a6&lang=scss&scoped=true"

import exportComponent from "/var/lib/buildkite-agent/builds/BKxAWS-i-0cc0aef14303b400c-1/assemble-sports/singaporerugby-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e0131a6"]])

export default __exports__